import React from "react";
import { Header, Layout, Metatags } from "@ADC/components/Views";
import Steps from "@ADC/components/Pages/Home/Form-3/Steps";
import { Footer } from "@ADC/components/Pages/ServiceAreasLanders";
import FAQs from "@ADC/components/Pages/NewLander/faqs";
import NewForm from "@ADC/components/Views/NewForm/Steps";
import { Link } from "gatsby";
import { Article } from "@ADC/components/Pages/ServiceAreasLanders/DebtRelief";
import NotFoundPage from "@ADC/pages/404";
import TrustedVoiceSlider from "@ADC/components/Views/TrustedVoiceSlider";

const IndividualDebtConsolidationInPage = (props) => {
  const {
    serverData: { data },
  } = props;
  const {
    phoneNumber,
    // heroSectionImage,
    // heroSectionVideo,
    heroSectionTitle,
    heroSectionDescription,
    isArticle,
    // address,
    name,
    // didYouKnow,
    articleContent,
  } = data?.attributes || {};

  const defaultDesc =
    "Affordable Debt Consolidation helps Texas residents struggling with unsecured debt find relief through our Texas Debt Relief Program. We specialize in debt consolidation, credit counseling, and financial education. Our approach ensures you regain control of your finances and eliminate debt burdens. Let us guide you toward a brighter financial future.";

  if (!data) {
    return <NotFoundPage />;
  } else {
    return (
      <Layout className="w-full h-full pt-[85px] lg:pt-32 desktop:pt-[150px] overflow-x-hidden">
        <Header phoneNumber={phoneNumber} />
        <div className="bg-debt-hero text-white pt-16 pb-16 lg:pb-0 px-6">
          <div className="max-w-[1340px] mx-auto grid grid-cols-1 lg:grid-cols-[61.2%_38.8%] gap-6 lg:gap-3 items-end">
            <div>
              <h1 className="text-[8vw] leading-normal sm:text-3xl lg:text-[52.3px] lg:leading-[73.13px] font-bold mb-6">
                Debt Consolidation: <br />
                One Easy Payment, <br />
                Real Debt Relief.
              </h1>

              <p className="text-[18px] lg:text-[20.27px] leading-[29.5px] lg:leading-[28.31px] font-semibold">
                Overwhelmed by Debt? You’re Not Alone.
              </p>

              <p className="text-[18px] lg:text-[20.27px] leading-[29.5px] lg:leading-[28.31px] text-white/90 mb-10 lg:me-6">
                At Affordable Debt Consolidation, we help Texans simplify their
                finances by combining{" "}
                <span className="font-bold">credit cards</span>,{" "}
                <span className="font-bold">medical bills</span>,{" "}
                <span className="font-bold">payday loans</span>, and more into
                one manageable monthly payment.
              </p>

              <div className="flex items-center justify-end max-lg:flex-col text-center lg:mb-[158px]">
                <div>
                  <h2 className="text-[30px] lg:text-[40.65px] leading-[34.2px] lg:leading-[46.33px] font-bold">
                    See What You Qualify for
                  </h2>
                  <p className="text-[16px] lg:text-[21.68px] leading-[26.2px] lg:leading-[35.5px] text-white/90">
                    Book Your Free Debt Consolidation Review
                  </p>
                </div>
                <img
                  src="/svgs/arrow-down.svg"
                  alt="Down Arrow"
                  width={118}
                  height={118}
                  className="mx-auto lg:mx-0 lg:hidden"
                />
                <img
                  src="/svgs/arrow-right.svg"
                  className="max-lg:hidden"
                  alt="Right Arrow"
                  width={106}
                  height={106}
                />
              </div>
            </div>

            <Steps />
          </div>
        </div>
        <TrustedVoiceSlider />
        <div className="bg-[#F4F4F4] px-[30px] py-6 lg:py-12">
          <div className="max-w-[1300px] mx-auto text-[#1F2937]">
            <h1 className="text-xl lg:text-3xl font-bold mb-4">
              {heroSectionTitle}
            </h1>
            <p className="text-base lg:text-xl">
              {heroSectionDescription ? heroSectionDescription : defaultDesc}
            </p>
          </div>
        </div>

        {isArticle && (
          <div className="px-[30px] py-12 text-[#2C6BB3]">
            <div className="max-w-[1300px] mx-auto">
              <Article content={articleContent.slice(0, 5)} />

              <NewForm />

              <Article
                content={articleContent.slice(5, articleContent.length)}
              />
            </div>
          </div>
        )}

        <div className="px-[30px] py-6 lg:py-12 bg-[#F4F4F4]">
          <div className="max-w-[1300px] mx-auto">
            <h2 className="text-xl lg:text-3xl font-bold mb-2 lg:mb-6 text-[#2C6BB3]">
              Why Choose Affordable Debt Consolidation in {name}?
            </h2>
            <p className="text-base lg:text-xl text-[#2C6BB3] lg:!text-[#1F2937]">
              At Affordable Debt Consolidation, we know that life in {name} can
              come with unique financial challenges. Whether you’re facing high
              living expenses, unexpected setbacks, or mounting credit card
              debt, we’re here to help you find a way forward. We serve only
              Texas residents, offering personalized debt consolidation programs
              with fees up to 40% lower than national providers. Our Certified
              Texas Debt Specialists provide compassionate, straightforward
              support designed to help you eliminate debt and feel more in
              control of your future.
            </p>
          </div>
        </div>
        <div className="px-[30px] py-12 text-[#2C6BB3]">
          <div className="max-w-[1300px] mx-auto">
            <div>
              <h2 className="text-xl lg:text-3xl font-bold mb-2">
                How to Get Started with Debt Consolidation in {name}
              </h2>
              <p className="text-base lg:text-xl text-[#2C6BB3] lg:text-[#1F2937]">
                Getting started is simple and stress-free. You can fill out our
                secure online form whenever you’re ready, or give us a call to
                speak directly with a Certified Texas Debt Specialist. We’ll
                listen to your situation, answer your questions, and walk you
                through your options. Our goal is to make the process clear and
                comfortable—so you can take the first step with confidence.
              </p>
            </div>

            <div className="max-lg:px-[18px]">
              <div className="mb-16 mt-10">
                <h2 className="text-xl lg:text-3xl font-bold mb-2">
                  Contact Us
                </h2>
                <p className="text-base lg:text-xl text-black">
                  <span className="font-bold text-[#2C6BB3]">
                    Phone Number:
                  </span>{" "}
                  <a className="underline" href={`tel:${phoneNumber}`}>
                    {phoneNumber}
                  </a>{" "}
                  <br />
                  <span className="font-bold text-[#2C6BB3]">
                    Business Hours:
                  </span>{" "}
                  Mon–Sat 8am–6pm <br />
                  <span className="font-bold text-[#2C6BB3]">
                    Corporate Office:
                  </span>{" "}
                  40 NE Interstate 410 Loop, San Antonio, TX 78216
                </p>
              </div>

              <div>
                <h2 className="text-xl lg:text-3xl font-bold mb-2">
                  Additional Resources for {name} Residents
                </h2>
                <ul className="px-1">
                  <li className="flex items-center gap-2 text-base lg:text-xl text-[#3A9746]">
                    <span>•</span>
                    <Link
                      to="/texas-resources/"
                      className="font-bold underline"
                    >
                      No-Cost Support Options for Texas Residents
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <FAQs />
        <Footer phoneNumber={phoneNumber} />
      </Layout>
    );
  }
};

export default IndividualDebtConsolidationInPage;

export const Head = ({ serverData: { data } }) => {
  return (
    <Metatags
      pageTitle={data?.attributes?.metaTitle}
      metaTitle={data?.attributes?.metxaTitle}
      description={data?.attributes?.metaDescription}
      keywords={data?.attributes?.metaKeywords}
      imageUrl={data?.attributes?.metaImage?.data?.attributes?.url}
      datePublished={data?.attributes?.publishedAt}
      dateModified={data?.attributes?.updatedAt}
      path={`/debt-consolidation-in${data?.attributes?.path}`}
      type="article"
    />
  );
};

export async function getServerData({ params: { slug } }) {
  try {
    const res = await fetch(
      `${process.env.ADC_API_URL}/adc-debt-settlement-in-landers?populate=*&sort=id:asc&filters[path][$eq]=/${slug}/`
    );

    if (!res.ok) {
      throw new Error(`Response failed`);
    }
    const data = await res.json();

    if (data?.data?.length) {
      return {
        props: { data: data?.data[0] },
      };
    } else {
      return {
        props: { data: null },
      };
    }
  } catch (error) {
    return {
      status: 500,
      headers: {},
      props: {},
    };
  }
}
